import { useContext } from 'react'
import { DomainContext } from './DomainProvider'

export function useDomain() {
    const context = useContext(DomainContext)

    if (context === null) {
        throw 'This hook must be used within a <Domain /> Context provider'
    }

    return context
}

export function useCurrentDomainContext() {
    const domain = useDomain()

    if (!domain.currentContext) {
        console.error('Domain provider does not have currentContext')
        throw 'Domain provider does not have currentContext'
    }

    return domain.currentContext
}

export function useJHireURL() {
    const domain = useDomain()

    if (!domain.jhire) {
        console.error('Domain provider does not have jhire')
        throw 'Domain provider does not have jhire'
    }

    return domain.jhire
}

export function useAdminURL() {
    const domain = useDomain()

    if (!domain.admin) {
        console.error('Domain provider does not have admin')
        throw 'Domain provider does not have admin'
    }

    return domain.admin
}
